module.exports = __webpack_public_path__ + "img/left.a4e66219.svg";